import React from 'react';
import PropTypes from 'prop-types';
import PercentageDataFact from './percentage-data-fact';
import NoPerformanceFee from './no-performance-fee';

export default function Fees(props) {
  const {
    managementFee,
    performanceFee,
    isPerformanceFeeCharged,
    totalCostRatio,
    financialYearEndFeesDate,
  } = props;

  const reportDate = financialYearEndFeesDate ? `(${financialYearEndFeesDate})` : null;
  const performanceFeeComponent = isPerformanceFeeCharged
    ? (
      <PercentageDataFact
        label="Actual performance Fee"
        value={performanceFee}
        nullReplacement="N/A"
        perAnnual
        date={reportDate}
      />
    )
    : <NoPerformanceFee />;

  return (
    <>
      <PercentageDataFact
        label="Management Fee"
        value={managementFee}
        nullReplacement="N/A"
        perAnnual
        clazz="first"
      />
      {performanceFeeComponent}
      <PercentageDataFact
        label="Total Cost Ratio"
        value={totalCostRatio}
        nullReplacement="N/A"
        perAnnual
        date={reportDate}
        clazz="last"
      />
    </>
  );
}

Fees.propTypes = {
  managementFee: PropTypes.string.isRequired,
  performanceFee: PropTypes.string,
  isPerformanceFeeCharged: PropTypes.bool.isRequired,
  totalCostRatio: PropTypes.string,
  financialYearEndFeesDate: PropTypes.string,
};

Fees.defaultProps = {
  performanceFee: null,
  totalCostRatio: null,
  financialYearEndFeesDate: null,
};
